import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=36a13be5"
import script from "./UserSubscriptions.vue?vue&type=script&lang=ts"
export * from "./UserSubscriptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports